module.exports = __webpack_public_path__ + "img/gift19.a1e7c631.png";